export const LANGUAGE_CODE = 'ja-JP';
export const MARKET_CODE = 'JPN';
export const CURRENCY_CODE = 'JPY';
export const SITE_IMAGE_URL =
  'https://img.travel.rakuten.co.jp/share/common/images/bnr_ogp_logo.gif';
export const DATED_AD_PAGE_TITLE = '注目宿泊施設';
export const BONUS_PROGRAM_PAGE_TITLE = 'ボーナスプログラム';
